import { BookingFormBasicProfile } from "PFApp/booking/components/booking_form/booking_form_provider";
import { BookingType } from "PFApp/booking/components/booking_form/booking_type";
import { ReactNode } from "react";

const PROFILES_COUNT_LIMIT_SINGLE_BOOKINGS = 300;
const PROFILES_COUNT_LIMIT_REPEATED_BOOKINGS = 50;

export type GroupBookingOption = {
  searchId: number;
  displayElement: ReactNode;
  disabled: boolean;
};

export const getGroupBookingId = (searchId: number) => `group-booking-${searchId}`;

export const isGroupOption = (
  option?: BookingFormBasicProfile | GroupBookingOption
): option is GroupBookingOption => !!option && "searchId" in option;

export const getProfilesLimit = (bookingType: BookingType) =>
  bookingType === BookingType.Single
    ? PROFILES_COUNT_LIMIT_SINGLE_BOOKINGS
    : PROFILES_COUNT_LIMIT_REPEATED_BOOKINGS;
